import ApiService from "../../services/apiService";
import { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDoorOpen,
  faWifi,
  faBatteryThreeQuarters,
  faSun,
  faTemperatureLow,
} from "@fortawesome/free-solid-svg-icons";
import ValveCompponent from "./ValveComponent";
import { format } from "date-fns";
import ProgressBar from "./ProgressBar";
import ScheduelPopup from "./ScheduelPopup";
import Calendar from "../calendar/Calendar";
import CalendarIcon from "../svg/Calendar";
import ScheduleIcon from "../svg/Schedule";
import Diagram from "../svg/Diagram";

import Concrete_Bed from "./3D_irrigation_renders/Concrete_bed2.png.svg";
import Main_line_green from "./3D_irrigation_renders/Main_line_red.svg";
import main_line_red from "./3D_irrigation_renders/Main_line_Red.svg.svg";
import pressuremeter from "./3D_irrigation_renders/Pressure_Metre.svg";
import Watermeter from "./3D_irrigation_renders/Water_Metre.svg";
import antenapole from "./3D_irrigation_renders/Pole_antenna.png";

const ChackComponent = ({ id, onClose }: { id: any; onClose: any }) => {
  const progressInterval = useRef<NodeJS.Timeout | null>(null);

  const [chackData, setChackData] = useState<any>([]);
  const [numberOfValve, setNumberOfValve] = useState<any>([]);
  const [progressBar, setProgressBar] = useState<boolean>(false);
  const [now, setNow] = useState<number>(0);
  const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false);
  const [selectedComponent, setSelectedComponent] = useState<string>();
  const [isSending, setIsSending] = useState<boolean>(false);

  const gradientStyle = {
    background: "linear-gradient(#b4ffee, #dffff8)",
    padding: "6px 0px",
  };

  useEffect(() => {
    const fetchChack = async () => {
      try {
        const response = await ApiService.axiosApi(`/chack/${id}`, {
          method: "GET",
          params: {
            pageNumber: 0,
            pageSize: 0,
          },
        });
        if (response.success) {
          const data = response.data;
          const final = Array.isArray(data) ? data : [data];
          setChackData(final);
        } else {
          toast.error("unable to load details");
          console.log(response.message || "getting problem in fetching api ");
        }
      } catch (error: any) {
        console.log(error);
      }
    };
    fetchChack();
    const chackIntervalId = setInterval(fetchChack, 10000);

    const fetchValve = async () => {
      try {
        const response = await ApiService.axiosApi(
          `/chackvalvedetail/chackid${id}`,
          { method: "GET" },
        );
        if (response.success) {
          setNumberOfValve(response.data);
        } else {
          console.log(response.message || "unable to fetch valve details");
        }
      } catch (error: any) {
        console.log(error);
      }
    };
    fetchValve();
    const valveIntervalId = setInterval(fetchValve, 5000);

    return () => {
      clearInterval(chackIntervalId);
      clearInterval(valveIntervalId);
    };
  }, [id]);

  const startProgressBar = () => {
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }

    setNow(0);
    setProgressBar(true);

    const stepTime = 250;
    const duration = 45000;
    const increment = 100 / (duration / stepTime);
    let current = 0;

    progressInterval.current = setInterval(() => {
      current += increment;
      if (current >= 100) {
        current = 100;
        clearInterval(progressInterval.current!);
        progressInterval.current = null;
      }
      setNow(current);
    }, stepTime);
  };

  const stopProgressBar = () => {
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }
    setNow(0);
    setProgressBar(false);
  };

  const sendIntgCommnad = async () => {
    console.log(isSending)
    if (isSending) return;
    setIsSending(true);
    startProgressBar();
  
    const safetyTimer = setTimeout(() => {
      setIsSending(false);
      stopProgressBar();
    }, 45000); // ✅ 45s ke baad force unlock, chahe kuch bhi ho
  
    try {
      const response = await ApiService.axiosApi(`/command/intg`, {
        method: "POST",
        data: { chakId: id, command: "INTG" },
      });
      if (response.success) toast.success("Success");
      else toast.error("Failed");
    } catch (e) {
      console.log(e);
      toast.error("Request failed or timed out");
    } finally {
      clearTimeout(safetyTimer);
      stopProgressBar();
      setIsSending(false);
    }
  };

  const sendAutoManualCommnad = async (data: any) => {
    if (isSending) return;
    setIsSending(true);
    startProgressBar();
    try {
      const response = await ApiService.axiosApi(`/command/auto/manual`, {
        method: "POST",
        data: {
          chakId: id,
          autoManual: data.romsAuto ? 1 : 0,
        },
      });
      if (response.success) {
        toast.success("Success");
      } else {
        toast.error("Failed");
      }
    } catch (e) {
      console.log(e);
    } finally {
      stopProgressBar();
    }
  };

  return (
    <>
      {progressBar && (
        <ProgressBar
          totalpage={0}
          pageNumber={0}
          now={now}
          mystyle={{
            position: "absolute",
            height: "25px",
            zIndex: 1000,
            backgroundColor: "whitesmoke",
            borderRadius: "4px",
            top: "-30px",
            padding: "0px 4px",
            width: "100%",
          }}
        />
      )}

      <div className="modal-content d-xl-flex">
        {chackData.map((data: any) => (
          <>
            <div className="modal-header" style={gradientStyle} key={data.id}>
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4">
                    <h5 className="modal-title " style={{ color: "GrayText" }}>
                      <strong>{data.chackName}</strong>
                    </h5>
                  </div>
                  <div className="col-md-3"></div>
                  <div className="col-md-5 text-end pt-1 px-4 d-flex justify-content-end align-items-center ">
                    {selectedComponent == "CalendarComponent" ? (
                      <div
                        onClick={() => {
                          setSelectedComponent("ChakComponent");
                        }}
                        style={{ zIndex: 10 }}
                        className="Calendar-Button me-1"
                      >
                        <Diagram />
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          setSelectedComponent("CalendarComponent");
                        }}
                        style={{ zIndex: 10 }}
                        className="Calendar-Button me-1"
                      >
                        <CalendarIcon />
                      </div>
                    )}

                    <Button
                      color="primary me-2"
                      onClick={sendIntgCommnad}
                      disabled={isSending}
                      style={{
                         zIndex:10
                      }}
                    >
                      Interrogate
                    </Button>
                    <Button
                      color={`${data.romsAuto ? "danger" : "primary"}`}
                      onClick={() => sendAutoManualCommnad(data)}
                      disabled={isSending}
                    >
                      {data.romsAuto ? "Roms Manual" : "Roms Auto"}
                    </Button>
                    <button className="chackbutton" onClick={onClose}>
                      X
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-body" style={{ width: "100%" }}>
              {selectedComponent == "CalendarComponent" ? (
                <Calendar ChakId={data.id} />
              ) : selectedComponent == "ScheduleComponent" ? (
                <ScheduelPopup
                  totalValves={data.no_Of_ON_OF_Valves}
                  ChakId={data.id}
                />
              ) : (
                <div className="row" style={{ width: "100%" }}>
                  <div
                    className="col-md-1 "
                    style={{ borderRight: "0.5px inset grey", height: "50%" }}
                  >
                    <ul className="pop-icons justify-content-center align-items-center">
                      <li
                        className={` d-flex flex-column align-items-center justify-content-center pb-4 ${
                          data.door1 == "Close" ? "green" : "red"
                        }`}
                      >
                        <div className=" ">
                          <FontAwesomeIcon icon={faDoorOpen} size="2x" />
                        </div>
                        <div className="  ">
                          {String(data.door1 == "Close" ? "close" : "open")}
                        </div>
                      </li>
                      <li
                        className={`pb-4  d-flex flex-column align-items-center justify-content-center ${
                          data.networkStatus == "Good"
                            ? "green"
                            : data.networkStatus == "Excellent"
                              ? "green"
                              : data.networkStatus == "Average"
                                ? "network-yellow"
                                : "red"
                        }`}
                      >
                        <div className=" ">
                          <FontAwesomeIcon icon={faWifi} size="2x" />
                        </div>
                        <div className="">{data.networkStatus}</div>
                      </li>
                      <li
                        className={`${
                          data.battery < 20 ? "red" : "green"
                        } pb-4 d-flex  d-flex flex-column align-items-center justify-content-center`}
                      >
                        <div className=" ">
                          <FontAwesomeIcon
                            icon={faBatteryThreeQuarters}
                            size="2x"
                          />
                        </div>
                        <div
                          className={`${data.battery < 20 ? "red" : "green"} `}
                        >
                          {data.battery}%
                        </div>
                      </li>
                      <li className=" green pb-4  align-items-center d-flex flex-column justify-content-center ">
                        <div className="   ">
                          <FontAwesomeIcon icon={faSun} size="2x" />
                        </div>
                        <div className=" ">{data.solarVoltage}V</div>
                      </li>
                      <li className="green d-flex flex-column align-items-center justify-content-center ">
                        <div className=" ">
                          <FontAwesomeIcon icon={faTemperatureLow} size="2x" />
                        </div>
                        <div className="  ">{data.temprature}&deg;C</div>
                      </li>
                    </ul>
                  </div>

                  <div className="col-md-8">
                    <div className="" id="valve-component">
                      <img id="antena_pole" src={antenapole} alt="" />
                      <img
                        id="Main_line_red"
                        src={`${
                          data.flowRate > 5 ? Main_line_green : main_line_red
                        }`}
                        alt=""
                      />
                      <img id="Concrete_Bed" src={Concrete_Bed} alt="" />
                      <img id="pressure-meter" src={pressuremeter} alt="" />
                      <img id="water-meter" src={Watermeter} alt="" />

                      {numberOfValve.map((valve: any, index: any) => (
                        <ValveCompponent
                          data={valve}
                          index={index}
                          chackData={data}
                        />
                      ))}
                    </div>
                  </div>

                  <div className="col-md-3 cardc  ">
                    <div className="card b-r-1" style={{ width: "100%" }}>
                      <div
                        className="card-header px-3 py-2  h-50"
                        style={gradientStyle}
                      >
                        <div className="float-left">
                          <h6
                            className="card-title mb-0"
                            style={{ color: "GrayText" }}
                          >
                            Details
                          </h6>
                        </div>
                        <div className="float-right text-end">
                          <span>
                            {format(
                              new Date(data.dateTime),
                              "yyyy-MM-dd HH:mm:ss",
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="card-body p-0 chackcard">
                        <table className=" table  table-hover table-striped custom-table  chackcard  ">
                          <tbody className="chackcard">
                            <tr>
                              <th> Chak Name</th>
                              <td> {data.chackName}</td>
                            </tr>
                            <tr>
                              <td>Chak Area</td>
                              <td>{data.chackArea}</td>
                            </tr>
                            <tr>
                              <td>Duty</td>
                              <td>{data.duty}</td>
                            </tr>
                            <tr>
                              <td>Roms Mode</td>
                              <td>
                                {String(
                                  data.romsAuto == true ? "auto" : "manual",
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>Flow Rate</td>
                              <td>{data.flowRate}</td>
                            </tr>
                            <tr>
                              <td>Today Volume</td>
                              <td>{data.todayVolume}</td>
                            </tr>
                            <tr>
                              <td>Pressure</td>
                              <td>{data.pressure}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default ChackComponent;
